module.exports = __webpack_public_path__ + "static/promo-text-306fa5b2749664597a8b241f8f6c94a7.svg";